import { useState } from 'react';

const DISMISS_KEY = 'sae-desktop-notice-dismissed';

/**
 * Slim advisory bar shown only on narrow viewports (owner direction,
 * 2026-10-17): SAE Studio's full workflow needs a desktop screen.
 * Width-based visibility lives in CSS (styles.css, .desktop-notice is
 * display:none at 760px and wider); this component only tracks the
 * dismissal, remembered for the session via sessionStorage.
 */
export function DesktopNotice() {
  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* Storage unavailable (private mode, blocked cookies): the
         dismissal still applies for the rest of this page session. */
    }
    setDismissed(true);
  };

  return (
    <div className="desktop-notice" role="note">
      <p>
        SAE Studio is designed for desktop use. The full workflow requires
        a larger screen. Open this address on a desktop or laptop computer
        to run the complete tool.
      </p>
      <button
        type="button"
        className="desktop-notice-close"
        aria-label="Dismiss desktop notice"
        onClick={dismiss}
      >
        ×
      </button>
    </div>
  );
}
